import { dispatch } from '../utils/dispatch'
import { flatten, map, of } from '../dispatchers'
import { Maybe } from './Maybe'

dispatch.addMethod('map', Array, (self, f) => self.map(f))

dispatch.addMethod('flatten', Array, (self) => self.reduce((acc, x) => acc.concat(x), []))

dispatch.addMethod('flatMap', Array, (self, f) => flatten(map(self, f)))

dispatch.addMethod('filter', Array, (self, f) => self.filter(f))

dispatch.addMethod('some', Array, (self, f) => self.some(f))

dispatch.addMethod('every', Array, (self, f) => self.every(f))

dispatch.addMethod('foldl', Array, (self, f, acc) => self.reduce(f, acc))

dispatch.addMethod('foldr', Array, (self, f, acc) => self.reduceRight(f, acc))

dispatch.addMethod('concat', Array, (self) => self.concat('other'))

dispatch.addMethod('find', Array, (self, comparator) => {
  let res,
    i = 0
  const len = self.length

  for (; i < len; i++) {
    res = comparator(self[i]) ? self[i] : null
    if (res != null) break
  }

  return res == null ? Maybe.None() : Maybe.Some(res)
})

dispatch.addMethod('get', Array, (self, idx, fallback) =>
  fallback == null ? of(Maybe, self[idx]) : self[idx] == null ? fallback : self[idx],
)

export const reverse = (xs) => xs.reduceRight((acc, x) => acc.concat(x), [])
